import { Data, Layout } from 'plotly.js';
import PlotlyBasic from 'plotly.js-basic-dist';
import React from 'react';
import createPlotlyComponent from 'react-plotly.js/factory';

import { AWS_ORANGE_COLOR, GREEN_COLOR, ON_PREMISES_COLOR } from '../../../common/colors';
import { constants } from '../../../common/Localization';
const PlotlyChart = createPlotlyComponent(PlotlyBasic);
import { MainframeCashflow } from './MainframeTypes';

const mode = 'lines+markers';
const type = 'scatter';
const hoverinfo = 'y';
const hoverformat = '.2s';
const config = { responsive: true };

export const CumulativeCostsChart = (currency: string, cashflow: MainframeCashflow) => {
    const xAxis = new Array(cashflow.duration).fill(0).map((zero, year) => year + 1);
    const onPremCumulative: Data = {
        hoverinfo,
        line: {
            color: ON_PREMISES_COLOR,
        },
        mode,
        name: constants.CUMULATIVE_NO_CHANGE,
        type,
        x: xAxis,
        y: cashflow.cumulativeStayOnPrem,
    };

    const awsCumulative: Data = {
        hoverinfo,
        line: {
            color: AWS_ORANGE_COLOR,
        },
        mode,
        name: constants.CUMULATIVE_AWS_MIGRATION,
        type,
        x: xAxis,
        y: cashflow.cumulativeMigrateToAWS,
    };

    const differenceCumulative: Data = {
        hoverinfo,
        line: {
            color: GREEN_COLOR,
        },
        mode,
        name: constants.CUMULATIVE_DIFFERENCE,
        type,
        x: xAxis,
        y: cashflow.cumulativeDifference,
    };

    const layout: Partial<Layout> = {
        autosize: true,
        legend: {
            orientation: 'h',
        },
        showlegend: true,
        title: constants.CUMULATIVE_CASHFLOW_TITLE,
        xaxis: {
            autorange: true,
            dtick: 1,
            hoverformat,
        },
        yaxis: {
            autorange: true,
            hoverformat,
            title: `${constants.COST_IN} ${currency}`,
        },
    };

    const data = [onPremCumulative, awsCumulative, differenceCumulative];
    return (<PlotlyChart data={data} config={config} layout={layout}/>);
};

export const AnnualCostsChart = (currency: string, cashflow: MainframeCashflow) => {
    const xAxis = new Array(cashflow.duration).fill(0).map((zero, year) => year + 1);
    const onPremAnnual: Data = {
        hoverinfo,
        line: {
            color: ON_PREMISES_COLOR,
        },
        mode,
        name: constants.TOTAL_NO_CHANGE,
        type,
        x: xAxis,
        y: cashflow.totalStayOnPrem,
    };

    const awsAnnual: Data = {
        hoverinfo,
        line: {
            color: AWS_ORANGE_COLOR,
        },
        mode,
        name: constants.TOTAL_AWS_MIGRATION,
        type,
        x: xAxis,
        y: cashflow.totalMigrateToAWS,
    };

    const differenceAnnual: Data = {
        hoverinfo,
        line: {
            color: GREEN_COLOR,
        },
        mode,
        name: constants.TOTAL_DIFFERENCE,
        type,
        x: xAxis,
        y: cashflow.totalDifference,
    };

    const layout: Partial<Layout> = {
        autosize: true,
        legend: {
            orientation: 'h',
        },
        showlegend: true,
        title: constants.TOTAL_CASHFLOW_TITLE,
        xaxis: {
            autorange: true,
            dtick: 1,
            hoverformat,
        },
        yaxis: {
            autorange: true,
            hoverformat,
            title: `${constants.COST_IN} ${currency}`,
        },
    };
    const data = [onPremAnnual, awsAnnual, differenceAnnual];
    return (<PlotlyChart data={data} config={config} layout={layout}/>);
};
